import * as z from "zod/v4";

export const confirmIntelligentInventoryTool = {
  name: "confirmIntelligentInventoryTool" as const,
  input: z.object({
    threadId: z.string(),
    toolCallId: z.string(),
    confirmed: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
